// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__WCVYk","contentWrapper":"App_contentWrapper__rzxoG","overlay":"App_overlay__3SzL3"};